import { AbstractCommand } from 'src/models/command';

class UnShareTheSharedQueryCommand extends AbstractCommand {
	readonly name = 'IFS_Organization_SharedQueries_Command_Command_UnShareTheSharedQuery';

	public constructor(sharedQueryId: string, userIdToUnShareWith: number) {
		super();
		this.parameters = {
			sharedQueryId: sharedQueryId,
			userIdToUnShareWith: userIdToUnShareWith,
		};
	}
}

export { UnShareTheSharedQueryCommand };
